import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface PhoneCallCapture {
  guid: string
  status: "initiating" | "ringing" | "in_progress" | "completed" | "failed"
}

interface CreatePhoneCallCaptureParams {
  phoneNumber: string
  householdId?: string
  meetingId?: string
  title?: string
}

export async function createPhoneCallCapture(
  context: ApiContext,
  params: CreatePhoneCallCaptureParams
): Promise<PhoneCallCapture> {
  return apiContextFetch<PhoneCallCapture>(context, "phone_call_captures", {
    method: "POST",
    body: JSON.stringify({
      phone_number: params.phoneNumber,
      household_id: params.householdId,
      meeting_id: params.meetingId,
      title: params.title,
    }),
  })
}
